import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Checkbox, Divider, Select, Tooltip } from 'antd';
import BOMActions from '@Actions/bomActions';
import './style.scss';
import H3Text from '@Uilib/h3Text';
import PRZSelect from '../../UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
class BomSelector extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      includeInActiveBOM: false,
    };
  }

  /**
   *
   */
  componentDidMount() {

  }

  /**
   *
   * @param props
   * @param state
   * @return {(*&)|*}
   */
  static getDerivedStateFromProps(props, state) {
    const {
      getBOM, user, tenantDepartmentId, boms, tenantId,
    } = props;
    const { isUserReady, includeInActiveBOM, selectedTenant } = state;
    if (selectedTenant !== tenantId) {
      getBOM(user?.tenant_info?.org_id, tenantId || user?.tenant_info?.tenant_id, '', '', !includeInActiveBOM ? true : '', '', 30, '', tenantDepartmentId, 'list');
      return {
        ...state,
        isUserReady: true,
        selectedTenant: tenantId,
      };
    }
    return state;
  }

  filterRestricted(item) {
    if ((item?.is_restricted && item?.bom_users.includes(this.props.user?.user_id)) || (!item?.is_restricted && item?.bom_users === null)) {
      return false
    } else return true
  }

  /**
   *
   * @return {*}
   */
  render() {
    const {
      boms, onChange, disabled, showError, title, hideTitle, containerClassName, inputClassName, labelClassName,
      getBOM, user, customStyle, emptyNotAllowed, tenantDepartmentId, placeholder, excludedProducts, getBOMLoading, tenantId,
    } = this.props;
    const { includeInActiveBOM } = this.state;
    return (
      <div className={`${containerClassName} select-bom__wrapper` || 'orgInputContainer select-department__wrapper'}>
        {!hideTitle ? (
          <label className={labelClassName || 'orgFormLabel'}>
            {title || 'Department'}
            <span style={{ color: 'red' }}>{'  *'}</span>
          </label>
        ) : <React.Fragment /> }
        <PRZSelect
          filterOption={false}
          disabled={disabled}
          onChange={(value) => onChange(boms?.bill_of_material?.find((bom) => bom?.bom_id === value))}
          className={inputClassName || ' input'}
          showSearch
          onSelect={() => {
            getBOM(user?.tenant_info?.org_id, tenantId || user?.tenant_info?.tenant_id, '', '', !includeInActiveBOM ? true : '', 1, 30, '', tenantDepartmentId, 'list');
          }}
          onSearch={(value) => {
            getBOM(user?.tenant_info?.org_id, tenantId || user?.tenant_info?.tenant_id, '', '', !includeInActiveBOM ? true : '', 1, 30, value, tenantDepartmentId, 'list');
          }}
          placeholder={placeholder}
          popupClassName="select-bom__dropdown"
          loading={getBOMLoading}
          dropdownRender={
            (menu) => (
              <React.Fragment>
                {menu}
                <Divider style={{ margin: '0px' }} />
                <div className="ant-col-md-12">
                  <div className="bom-selector__checkbox">
                    <Checkbox
                      checked={includeInActiveBOM}
                      onChange={() => {
                        getBOM(user?.tenant_info?.org_id, tenantId || user?.tenant_info?.tenant_id, '', '', includeInActiveBOM ? true : '', 1, 30, '', tenantDepartmentId, 'list');
                        this.setState({ includeInActiveBOM: !includeInActiveBOM });
                      }}
                      className=""
                    >
                      Include Inactive BOMs
                    </Checkbox>
                  </div>
                </div>
              </React.Fragment>
            )
          }
          showError={showError}
          errorName="*Please select department"
          errorClassName="input-error"
        >
          {!emptyNotAllowed && (
            <Option key="NULL" value="">
              Select product
            </Option>
          )}
          {boms && boms?.bill_of_material
            ?.filter((item) => !excludedProducts.includes(item?.tenant_product_info?.tenant_product_id.toString()))?.filter((item) => !this.filterRestricted(item))
            ?.map((item) => (
              <Option key={item?.bom_id} value={item?.bom_id}>
                <Tooltip
                  title= {
                    <>
                      <div>#{item?.internal_sku_code}</div>
                      <div>{item?.ref_product_code}</div>
                    </>
                  }
                >
                  <div className="select-bom__item">
                    <div style={{ lineHeight: '18px', marginBottom: '5px' }}>
                      {`${item?.bom_number} - ${item?.bom_alias_name}`}
                    </div>
                    <H3Text text={item?.product_sku_name} className="table-subscript" />
                  </div>
                </Tooltip>
              </Option>
            ))}
        </PRZSelect>
      </div>

    );
  }
}

const mapStateToProps = ({ UserReducers, BOMReducers }) => ({
  getBOMLoading: BOMReducers.getBOMLoading,
  boms: BOMReducers.billOfMaterials,
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
  getBOM: (orgId, tenantId, selectedBom, productSkuId, status, page, limit, searchKeyword, tenantDepartmentId, responseType, callback) => dispatch(BOMActions.getBOM(orgId, tenantId, selectedBom, productSkuId, status, page, limit, searchKeyword, tenantDepartmentId, responseType, callback)),
});

BomSelector.propTypes = {
  user: PropTypes.any,
  getBOM: PropTypes.func,
  getBOMLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool,
  title: PropTypes.any,
  hideTitle: PropTypes.bool,
  containerClassName: PropTypes.any,
  tenantDepartmentId: PropTypes.any,
  inputClassName: PropTypes.any,
  labelClassName: PropTypes.string,
  customStyle: PropTypes.any,
  tenantId: PropTypes.any,
  selectedBom: PropTypes.any,
  boms: PropTypes.any,
  emptyNotAllowed: PropTypes.bool,
  excludedProducts: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BomSelector));
